import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input, Text } from "@fragments";
import { WallpaperRounded, TuneRounded } from "@mui/icons-material";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import {
    CommunityAssetImageField,
    AssetCategory,
} from "@features/uploadAsset";
import { MaterialValidation } from "../../enums";
import "./styles.scss";

export default function General({ configRef, communityId, onUploadingChange }) {
    const { t } = useTranslation("contentModals");
    const [allowDownload, setAllowDownload] = useState(
        () => configRef.current.allow_download !== false
    );
    const [, setRender] = useState(0);
    const bump = () => setRender((n) => n + 1);

    function handleAllowDownloadChange(v) {
        setAllowDownload(v);
        configRef.current.allow_download = v;
    }

    return (
        <>
            <Text.h3
                icon={<WallpaperRounded />}
                className="mt-3"
                value={t("manageMaterial.bannerSectionTitle")}
            />

            <div className="general__banner-add mt-2 mb-3">
                <CommunityAssetImageField
                    communityId={communityId}
                    category={AssetCategory.MATERIAL_BANNER}
                    value={configRef.current.banner}
                    onChange={(url) => {
                        configRef.current.banner = url;
                        bump();
                    }}
                    onUploadingChange={onUploadingChange}
                    aspectRatio={1 / 1.4142}
                    size={160}
                    imageMaxWidth={720}
                    title={t("manageMaterial.bannerCropTitle")}
                />
            </div>

            <Text.h3 left={<TuneRounded />} value={t("manageMaterial.generalSettings")} />

            <Input.Text
                placeholder={t("manageMaterial.namePlaceholder")}
                value={configRef.current.name}
                onInput={(v) => {
                    configRef.current.name = v;
                }}
                className="mt-3"
                label={t("manageMaterial.nameLabel")}
                size={MaterialValidation.NAME_MAX_LENGTH}
            />

            <Text.h3
                left={<FileDownloadRoundedIcon />}
                className="mt-4"
                value={t("manageMaterial.allowDownloadTitle")}
            />

            <Input.Switch
                className="mt-1"
                value={allowDownload}
                onInput={handleAllowDownloadChange}
                label={
                    allowDownload
                        ? t("manageMaterial.allowDownloadOn")
                        : t("manageMaterial.allowDownloadOff")
                }
            />
        </>
    );
}
